import React from 'react'
import { PreferencesView } from './components/PreferencesView'

export const PreferencesTab: React.FC = () => {
  return <PreferencesView />
}